<dx-popup
  #dlgCloseTill
  [width]="650"
  [height]="406"
  [showTitle]="true"
  title="Cash Up"
  [resizeEnabled]="true"
  [dragEnabled]="true"
  [showCloseButton]="true"
  [hideOnOutsideClick]="false"
  (onContentReady)="onContentReady($event)"
  (onShown)="onShown($event)"
  (onHidden)="onHidden($event)"
>
  <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="before" [options]="CheckTransactionsButtonOptions">
  </dxi-toolbar-item>
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [disabled]="!isCashUpFormValid"
    [options]="OkButtonOptions"
  >
  </dxi-toolbar-item>
  <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="CancelButtonOptions">
  </dxi-toolbar-item>

  <div *dxTemplate="let data of 'content'">
    <dx-form
      #cashUpInfoForm
      [formData]="cashUpInfo"
      [colCount]="2"
      (onFieldDataChanged)="onCashUpFormDataChanged($event)"
    >
      <dxi-item
        dataField="TerminalName"
        caption="Terminal"
        editorType="dxTextBox"
        [editorOptions]="{ readOnly: true }"
        [colSpan]="2"
      >
      </dxi-item>
      <dxi-item itemType="simple" [colSpan]="2">
        Please include full contents of the till including any cash that was used as a float
      </dxi-item>
      <dxi-item
        dataField="CashTotal"
        caption="Cash Total"
        editorType="dxNumberBox"
        [editorOptions]="{
          format: '£#,##0.00',
          min: '0.0',
          max: '99999.99',
          showSpinButtons: true,
        }"
      >
      </dxi-item>
      <dxi-item
        dataField="CardTotal"
        caption="Card Total"
        editorType="dxNumberBox"
        [editorOptions]="{
          format: '£#,##0.00',
          min: '0.0',
          max: '99999.99',
          showSpinButtons: true,
        }"
      >
      </dxi-item>

      <dxi-item dataField="StartDate" dataType="date" editorType="dxDateBox" [editorOptions]="dateEditorOptions">
        <dxi-validation-rule type="required" message="Start Date is required"> </dxi-validation-rule>
        <dxi-validation-rule
          type="custom"
          message="Start Date must not be after the End Date"
          ignoreEmptyValue="true"
          reevaluate="true"
          [validationCallback]="validateStartDate"
        >
        </dxi-validation-rule>
      </dxi-item>

      <dxi-item dataField="EndDate" dataType="date" editorType="dxDateBox" [editorOptions]="dateEditorOptions">
        <dxi-validation-rule type="required" message="End Date is required"> </dxi-validation-rule>
        <dxi-validation-rule
          type="custom"
          message="End Date must not be before the Start Date"
          ignoreEmptyValue="true"
          reevaluate="true"
          [validationCallback]="validateEndDate"
        >
        </dxi-validation-rule>
      </dxi-item>

      <dxi-item dataField="StartTime" dataType="date" editorType="dxDateBox" [editorOptions]="timeEditorOptions">
        <dxi-validation-rule type="required" message="Start Time is required"> </dxi-validation-rule>
        <dxi-validation-rule
          type="custom"
          message="Start Time must be earlier than End Time"
          ignoreEmptyValue="true"
          reevaluate="true"
          [validationCallback]="validateStartTime"
        >
        </dxi-validation-rule>
      </dxi-item>

      <dxi-item dataField="EndTime" dataType="date" editorType="dxDateBox" [editorOptions]="timeEditorOptions">
        <dxi-validation-rule type="required" message="End Time is required"> </dxi-validation-rule>
        <dxi-validation-rule
          type="custom"
          message="End Time must be later than Start Time"
          ignoreEmptyValue="true"
          reevaluate="true"
          [validationCallback]="validateEndTime"
        >
        </dxi-validation-rule>
      </dxi-item>
    </dx-form>
  </div>
</dx-popup>

<dx-popup
  #dlgReportingPassword
  [width]="500"
  [height]="205"
  [showTitle]="true"
  title="Reporting Password"
  [resizeEnabled]="false"
  [dragEnabled]="false"
  [showCloseButton]="true"
  [hideOnOutsideClick]="false"
  [(visible)]="reportingPasswordDialogVisible"
  (onHiding)="onReportingPasswordDialogHiding()"
>
  <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="ReportingPasswordOkButtonOptions">
  </dxi-toolbar-item>
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="ReportingPasswordCancelButtonOptions"
  >
  </dxi-toolbar-item>
  <dx-form
    #reportingPasswordForm
    [colCount]="2"
    [formData]="reportingPasswordFormData"
    (onFieldDataChanged)="onReportingPasswordFormDataChanged($event)"
  >
    <dxi-item dataField="reportingPassword" [colSpan]="2">
      <dxi-validation-rule type="required" message="Reporting Password is required"> </dxi-validation-rule>
    </dxi-item>
  </dx-form>
</dx-popup>

<app-sales-transaction-list
  [cashUpDialogVisible]="cashUpDialogVisible"
  [popupVisible]="salesTransactionListDialogVisible"
  (closeDlg)="OnCloseSalesTransactionListDlg($event)"
></app-sales-transaction-list>

<app-close-till-discrepancy (CloseDlg)="OnCloseDiscrepancyDlg($event)"></app-close-till-discrepancy>
